import { sidebarConfig, SidebarItemKey } from "../../config/sidebarConfig";
import type { AuthUser } from "../../types/authUser";
import { canOpenSidebarItem } from "../navigation/sidebarAccess";

export type PageResult = { key: SidebarItemKey; label: string; path: string };

/**
 * Sidebar pages whose name matches what's being typed, for instant search.
 * Only pages the person can open right now are returned.
 */
export function searchPages(
  text: string,
  user: AuthUser | null | undefined
): PageResult[] {
  const query = text.toLowerCase().trim();
  if (query.length < 2) return [];
  const typedWords = query.split(/[^a-z0-9]+/).filter((w) => w.length >= 2);

  return sidebarConfig.navItems
    .filter((item) => {
      const label = item.label.toLowerCase();
      const labelWords = label.split(" ");
      return (
        label.startsWith(query) ||
        labelWords.some((lw) => lw.startsWith(query)) ||
        typedWords.some((tw) => labelWords.includes(tw)) ||
        typedWords.includes(label.replace(" ", ""))
      );
    })
    .filter((item) => canOpenSidebarItem(item, user))
    .map(({ key, label, path }) => ({ key, label, path }));
}
